import React, { useRef, useState } from "react";
import { Play, Pause } from "lucide-react";
import { resolveMedia } from "@/lib/api";
import { useUI } from "@/context/AppContext";

// Click-to-play, muted, no autoplay-with-sound. Optimized for mobile.
export default function VideoPlayer({ src, poster, className = "", testId }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const ui = useUI();
  if (!src) return null;

  const toggle = () => {
    const v = ref.current;
    if (!v) return;
    if (v.paused) { v.play(); setPlaying(true); }
    else { v.pause(); setPlaying(false); }
  };

  return (
    <div className={`relative group overflow-hidden ${className}`} data-testid={testId}>
      <video
        ref={ref}
        src={resolveMedia(src)}
        poster={poster ? resolveMedia(poster) : undefined}
        muted
        playsInline
        preload="metadata"
        onEnded={() => setPlaying(false)}
        className="h-full w-full object-cover"
      />
      <button
        type="button"
        onClick={toggle}
        aria-label={ui.play_video}
        data-testid={`${testId}-toggle`}
        className="absolute inset-0 flex items-center justify-center bg-black/20 transition-colors hover:bg-black/30"
      >
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-white/90 text-[#4E7D2C] shadow-lg transition-transform duration-300 group-hover:scale-110">
          {playing ? <Pause className="h-6 w-6" /> : <Play className="ml-1 h-6 w-6" />}
        </span>
      </button>
    </div>
  );
}
